declare var Morris: any;
declare var Chart: any;

namespace GeniuzPos.Common {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.resizable()
    @Serenity.Decorators.maximizable()
    export class DashboardChart extends Serenity.TemplatedWidget<any> {
        private areaChart: any;
        private barChartData: any;

        static initializeChart() {
            $(function () {
                //Common.DashboardChart.initializeChart();

                //Common.DashboardPageService.CountByStatus({}, response => {
                //    this.areaChart = new Morris.Bar({
                //        element: 'revenue-chart',
                //        resize: true, parseTime: false,
                //        data: response.Values,
                //        xkey: 'Month',
                //        ykeys: response.StatusKeys, labels: response.StatusLabels, hideHover: 'auto'
                //    });
                //});
            });
        }
    }
}
